/**
 * Catálogo canónico de perfiles RRHH (LINC/MLA) — debe mantenerse alineado con
 * `amaia/src/chat/rrhh_profiles.py` del backend.
 */
export interface RrhhEmployeeProfile {
  slug: string;
  label: string;
  disambig_reply: string;
}

export const RRHH_DOMAIN = 'RRHH_EMPLEADOS';
export const RRHH_PROMPT_ID = 'amaia_rrhh_main';
export const RRHH_INDEX_HINTS = ['linc_index', 'mla_index'] as const;

export const RRHH_EMPLOYEE_PROFILES: RrhhEmployeeProfile[] = [
  {
    slug: 'piloto_activo_am',
    label: 'Piloto activo Aeroméxico (planta)',
    disambig_reply: 'Soy piloto activo de Aeroméxico en planta.'
  },
  {
    slug: 'piloto_activo_amc',
    label: 'Piloto activo Aeroméxico Connect (AMC)',
    disambig_reply: 'Soy piloto activo de Aeroméxico Connect (AMC).'
  },
  {
    slug: 'sobrecargo_activo_am',
    label: 'Sobrecargo activo Aeroméxico (planta)',
    disambig_reply: 'Soy sobrecargo activo de Aeroméxico en planta.'
  },
  {
    slug: 'sobrecargo_activo_amc',
    label: 'Sobrecargo activo Aeroméxico Connect (AMC)',
    disambig_reply: 'Soy sobrecargo activo de Aeroméxico Connect (AMC).'
  },
  {
    slug: 'nsd_1_8',
    label: 'Personal NSD niveles 1-8',
    disambig_reply: 'Soy empleado de personal NSD (niveles 1-8).'
  },
  {
    slug: 'nsd_10_12',
    label: 'Personal NSD niveles 10-12',
    disambig_reply: 'Soy empleado de personal NSD (niveles 10-12).'
  },
  {
    slug: 'nsd_13_14',
    label: 'Personal NSD niveles 13-14',
    disambig_reply: 'Soy empleado de personal NSD (niveles 13-14).'
  },
  {
    slug: 'tierra_activo_am',
    label: 'Personal de tierra activo Aeroméxico',
    disambig_reply: 'Soy personal de tierra activo de Aeroméxico.'
  },
  {
    slug: 'tierra_activo_amc',
    label: 'Personal de tierra activo AMC',
    disambig_reply: 'Soy personal de tierra activo de Aeroméxico Connect (AMC).'
  },
  {
    slug: 'venta_especial',
    label: 'Venta especial LINC',
    disambig_reply: 'Soy empleado de venta especial.'
  },
  {
    slug: 'cobus',
    label: 'COBUS',
    disambig_reply: 'Soy empleado COBUS.'
  },
  {
    slug: 'pases_comision_nsd',
    label: 'Pases comisión de servicios NSD',
    disambig_reply: 'Soy empleado NSD con pases por comisión de servicios.'
  }
];

export function findRrhhProfile(
  slug: string | null | undefined
): RrhhEmployeeProfile | undefined {
  if (!slug) return undefined;
  return RRHH_EMPLOYEE_PROFILES.find((p) => p.slug === slug);
}
